import { render, staticRenderFns } from "./other-property-summary.vue?vue&type=template&id=636f2889&scoped=true"
import script from "./other-property-summary.vue?vue&type=script&lang=ts"
export * from "./other-property-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f2889",
  null
  
)

export default component.exports